import BlogsPage from './BlogsPage';

export default BlogsPage;



// WEBPACK FOOTER //
// ./src/components/BlogsPage/index.js